<template>
  <div id="nav-menu">
    <header>
      <b-navbar toggleable="lg" sticky class="shadow-sm p-0 bg-white">
        <b-navbar-brand to="/"><img src="./../../assets/images/logo.png" height="60"></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse" @click="$bvModal.show('modal-menu')"></b-navbar-toggle>
        <b-collapse is-nav>
          <b-navbar-nav class="ml-lg-5">
            <b-nav-item to="/">{{$t('menu.home')}}</b-nav-item>
            <b-nav-item to="/unit-list">{{$t('menu.unit')}}</b-nav-item>
            <b-nav-item to="/about-us">{{$t('menu.about')}}</b-nav-item>
            <b-nav-item to="/register">{{$t('menu.register')}}</b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-text class="height-nav mr-lg-3" style="width: 70px;">
              <a href="#" :class="{'active-lang': $i18n.locale == 'TH'}" @click="changeLocale('TH')">TH</a>
              <span class="mx-1">|</span>
              <a href="#" :class="{'active-lang': $i18n.locale == 'EN'}" @click="changeLocale('EN')">EN</a>
            </b-nav-text>
            <b-nav-text class="height-nav text-center box-left-shadow cursor-pointer" @click="openModal()"
              v-if="!userInfo">
              <i class="sprite icon-user mr-2"></i>
              <div class="d-inline-block mb-0"><b>{{$t('menu.loginAgent')}}</b></div>
            </b-nav-text>
            <b-nav-text class="height-nav text-center box-left-shadow cursor-pointer d-block block-login"
              v-if="userInfo">
              <p class="float-left mr-2" v-if="userInfo.profileImage">
                <img :src="userInfo.profileImage" width="50" class="mt-2 rounded-circle">
              </p>
              <p class="float-left text-left pt-1">
                {{userInfo.firstName}} {{userInfo.lastName}} <br>
                <b>{{$t('menu.logout')}}</b>
              </p>
              <div class="dropdown-login">
                <div class="block-user">
                  <router-link to="/my-account">
                    <div id="icon-login-user" class="mr-1"></div> {{$t('menu.myAccount')}}
                  </router-link>
                </div>
                <div class="block-doc mt-2">
                  <router-link to="/dashboard">
                    <div id="icon-login-doc" class="mr-1"></div> {{$t('menu.dashboard')}}
                  </router-link>
                </div>
                <div class="block-out mt-2" @click="logout()">
                  <div id="icon-login-out" class="mr-1"></div> {{$t('menu.logout')}}
                </div>
              </div>
            </b-nav-text>
            <b-nav-text class="height-nav text-center bg-blue">
              <a href="tel:+66066098 6309" class="text-white">
                <div class="float-left"><i class="sprite icon-tel mr-2"></i></div>
                <div class="float-left"><b>{{$t('menu.callUs')}}</b></div>
              </a>
            </b-nav-text>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <div class="d-block d-md-none">
        <div class="height-nav text-center box-left-shadow cursor-pointer" @click="openModal()" v-if="!userInfo">
          <i class="sprite icon-user mr-2"></i>
          <div class="d-inline-block mb-0"><b>{{$t('menu.loginAgent')}}</b></div>
        </div>
        <div class="height-nav text-center box-left-shadow cursor-pointer" v-if="userInfo">
          <p class="float-left mr-2" v-if="userInfo.profileImage">
            <img :src="userInfo.profileImage" width="50" class="mt-2">
          </p>
          <p class="float-left text-left pt-1" @click="dropdownMobile = !dropdownMobile">
            {{userInfo.firstName}} {{userInfo.lastName}} <br>
            <b>{{$t('menu.logout')}}</b>
          </p>
          <div class="dropdown-login-mobile" :class="{ 'd-block': dropdownMobile, 'd-none': !dropdownMobile }">
            <div class="block-user" @click="dropdownMobile = false">
              <router-link to="/my-account">
                <div id="icon-login-user" class="mr-1"></div> {{$t('menu.myAccount')}}
              </router-link>
            </div>
            <div class="block-doc mt-2" @click="dropdownMobile = false">
              <router-link to="/dashboard">
                <div id="icon-login-doc" class="mr-1"></div> {{$t('menu.dashboard')}}
              </router-link>
            </div>
            <div class="block-out mt-2" @click="logout()">
              <div id="icon-login-out" class="mr-1"></div> {{$t('menu.logout')}}
            </div>
          </div>
        </div>
        <div class="height-nav text-center bg-blue text-white">
          <a href="tel:+66066098 6309" class="text-white">
            <div class="float-left"><i class="sprite icon-tel mr-2"></i></div>
            <div class="float-left"><b>{{$t('menu.callUs')}}</b></div>
          </a>
        </div>
      </div>

      <b-modal id="modal-login" centered>
        <template v-slot:modal-header="{ close }">
          <h2 class="text-right w-100 mb-0">
            <img src="./../../assets/images/icon/close.png" @click="close()" class="cursor-pointer" width="25">
          </h2>
        </template>
        <template v-slot:default>
          <form @submit.stop.prevent="login">
            <div class="text-center">
              <h4><b>{{$t('modal.login')}}</b></h4>
              <div class="py-4 px-5">
                <b-form-input id="username" name="username" v-model="formLogin.username"
                  v-validate="{ required: true, email: true }" :state="validateState('username')"
                  :placeholder="$t('placeholder.email') + '*'">
                </b-form-input>
                <b-form-input class="mt-3" type="password" id="password" name="password" v-model="formLogin.password"
                  v-validate="{ required: true }" :state="validateState('password')"
                  :placeholder="$t('placeholder.password') + '*'">
                </b-form-input>
                <div v-if="formLogin.msgError" class="text-danger pt-2 text-left">* {{formLogin.msgError}}</div>
              </div>
            </div>
            <div class="px-5">
              <div class="float-left pt-3 cursor-pointer" @click="forgotPassModal()">
                <u>{{$t('modal.forgotPassword')}}</u>
              </div>
              <div class="float-right">
                <button class="btn btn-primary mt-2 mb-5"><b>{{$t('modal.login')}}</b></button>
              </div>
            </div>
          </form>
        </template>
      </b-modal>

      <b-modal id="modal-forgot" centered>
        <template v-slot:modal-header="{ close }">
          <h2 class="text-right w-100 mb-0">
            <img src="./../../assets/images/icon/close.png" @click="close()" class="cursor-pointer" width="25">
          </h2>
        </template>
        <template v-slot:default>
          <form @submit.stop.prevent="forgotPassword">
            <div class="text-center">
              <h4><b>{{$t('modal.forgotPasswordNotQ')}}</b></h4>
              <div class="pt-4 pb-2 px-5">
                <b-form-input id="emailForgot" name="emailForgot" v-model="emailForgot"
                  v-validate="{ required: true, email: true }" :state="validateState('emailForgot')"
                  :placeholder="$t('placeholder.email') + '*'">
                </b-form-input>
                <div v-if="msgErrorForgot" class="text-danger pt-2 text-left">* {{msgErrorForgot}}</div>
              </div>
            </div>
            <div class="text-center">
              <button class="btn btn-primary mt-2 mb-4"><b>{{$t('button.submit')}}</b></button>
            </div>
            <div class="text-center pb-4"><b>ลืมอีเมลในการสมัคร?</b><br>กรุณาติดต่อเจ้าหน้าที่ : <b><u>+66(0) 6 6098
                  6309</u></b></div>
          </form>
        </template>
      </b-modal>
      <b-modal id="modal-forgot-success" centered>
        <template v-slot:modal-header="{ close }">
          <h2 class="text-right w-100 mb-0">
            <img src="./../../assets/images/icon/close.png" @click="close()" class="cursor-pointer" width="25">
          </h2>
        </template>
        <template v-slot:default>
          <div class="text-center">
            <h4><b>ยืนยันการส่งอีเมล</b></h4>
            <div class="pt-4 pb-2 px-5">
              <div class="text-center">
                <div>ทางเจ้าหน้าที่ได้ส่งการเปลี่ยนรหัสผ่านใหม่ของคุณเรียบร้อยแล้ว<br>กรุณาตรวจสอบอีเมลของคุณ เพื่อเข้าสู่ระบบ </div>
                <button class="btn btn-primary mt-2 mb-4" @click="backHome()"><b>{{$t('button.backHome')}}</b></button>
              </div>
            </div>
          </div>
        </template>
      </b-modal>

      <b-modal id="modal-menu" class="m-0">
        <template v-slot:modal-header="{ close }">
          <h2 class="text-right w-100 mb-0">
            <img src="./../../assets/images/icon/close.png" @click="close()" class="cursor-pointer" width="25">
          </h2>
        </template>
        <template v-slot:default>
          <div class="text-center border-bottom pb-2 pt-5" @click="hideModal()"><b>
              <router-link to="/">{{$t('menu.home')}}</router-link>
            </b></div>
          <div class="text-center border-bottom pb-2 pt-4" @click="hideModal()"><b>
              <router-link to="/unit-list">{{$t('menu.unit')}}</router-link>
            </b></div>
          <div class="text-center border-bottom pb-2 pt-4" @click="hideModal()"><b>
              <router-link to="/about-us">{{$t('menu.about')}}</router-link>
            </b></div>
          <div class="text-center border-bottom pb-2 pt-4" @click="hideModal()"><b>
              <router-link to="/register">{{$t('menu.register')}}</router-link>
            </b></div>
          <div class="text-center pb-2 pt-4">
            <b>
              <a href="#" :class="{'active-lang': $i18n.locale == 'TH'}" @click="changeLocale('TH')">TH</a>
              <span class="mx-2">|</span>
              <a href="#" :class="{'active-lang': $i18n.locale == 'EN'}" @click="changeLocale('EN')">EN</a>
            </b>
          </div>
        </template>
      </b-modal>
    </header>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        formLogin: {
          username: '',
          password: '',
          msgError: ''
        },
        userInfo: localStorage.getItem('agenthub-info') ? JSON.parse(localStorage.getItem('agenthub-info')) : null,
        dropdownMobile: false,
        emailForgot: '',
        msgErrorForgot: ''
      }
    },
    methods: {
      openModal() {
        this.formLogin = {
          username: '',
          password: '',
          msgError: ''
        }
        this.$bvModal.show('modal-login')
      },
      hideModal() {
        this.$bvModal.hide('modal-menu')
      },
      login() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            return;
          }
          let loading = this.$loading.show()
          const formData = new FormData
          formData.append('email', this.formLogin.username)
          formData.append('password', this.formLogin.password)
          this.$http.post(this.$app.baseURL + this.$path.userLogin, formData).then(
            res => {
              loading.hide()
              if (res.data.status == 200 && res.data.data[0].agentType == 'A') {
                this.$bvModal.hide('modal-login')
                localStorage.setItem('agenthub-info', JSON.stringify(res.data.data[0]))
                this.userInfo = JSON.parse(localStorage.getItem('agenthub-info'))
                this.$router.replace('/dashboard')
              } else {
                localStorage.removeItem('agenthub-info')
                this.userInfo = null
                this.formLogin.msgError = res.data.message_TH;
              }
            }, () => {
              loading.hide()
              localStorage.removeItem('agenthub-info')
              this.userInfo = null
            }
          )
        })
      },
      logout() {
        this.dropdownMobile = false
        let loading = this.$loading.show()
        this.$http.post(this.$app.baseURL + this.$path.userLogout, '', {
          'headers': {
            'token': this.userInfo.token
          }
        }).then(
          () => {
            loading.hide()
            this.resetForm()
            this.$router.replace('/')
          }, () => {
            loading.hide()
            this.resetForm()
            this.$router.replace('/')
          }
        )
      },
      validateState(ref) {
        if (this.$veeFields[ref] && (this.$veeFields[ref].dirty || this.$veeFields[ref].validated)) {
          return !this.$veeErrors.has(ref);
        }
        return null;
      },
      resetForm() {
        localStorage.removeItem('agenthub-info')
        this.userInfo = null
        this.formLogin = {
          username: '',
          password: ''
        }
        this.$nextTick(() => {
          this.$validator.reset();
        })
      },
      forgotPassModal() {
        this.$bvModal.show('modal-forgot')
        this.$bvModal.hide('modal-login')
        this.msgErrorForgot = ''
      },
      forgotPassword() {
         this.$validator.validateAll().then(result => {
          if (!result) {
            return;
          }
          let loading = this.$loading.show()
          const formData = new FormData
          formData.append('email', this.emailForgot)
          this.$http.post(this.$app.baseURL + this.$path.forgot, formData).then(
            res => {
              loading.hide()
              if (res.data.status == 200) {
                this.$bvModal.hide('modal-forgot')
                this.$bvModal.show('modal-forgot-success')
              } else {
                this.msgErrorForgot = res.data.message_TH;
              }
            }, () => {
              loading.hide()
            }
          )
         });
      },
      backHome() {
        this.$bvModal.hide('modal-forgot-success')
        this.$router.replace('/')
      }
    }
  }
</script>

<style scoped>
  .height-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 220px;
    height: 80px;
  }

  .box-left-shadow {
    -webkit-box-shadow: -2px 0px 5px 0px rgba(0, 0, 0, 0.26);
    -moz-box-shadow: -2px 0px 5px 0px rgba(0, 0, 0, 0.26);
    box-shadow: -2px 0px 5px 0px rgba(0, 0, 0, 0.26);
  }

  .dropdown-login {
    display: none;
    position: absolute;
    min-width: 250px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    margin-left: -1.5rem;
    background-color: #fff;
    text-align: left;
    padding: 20px;
    top: 80px;
  }

  .dropdown-login-mobile {
    display: none;
    position: absolute;
    min-width: 250px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    margin-left: 22px;
    background-color: #fff;
    text-align: left;
    padding: 20px;
    top: 130px;
  }

  .block-login:hover .dropdown-login {
    display: block;
  }

  #icon-login-user {
    display: inline-block;
    background-image: url('./../../assets/images/icon/icon-user-black.png');
    width: 25px;
    height: 26px;
  }

  #icon-login-doc {
    display: inline-block;
    background-image: url('./../../assets/images/icon/icon-doc-black.png');
    width: 21px;
    height: 24px;
  }

  #icon-login-out {
    display: inline-block;
    background-image: url('./../../assets/images/icon/icon-out-black.png');
    width: 25px;
    height: 21px;
  }

  .block-user:hover #icon-login-user {
    background-image: url('./../../assets/images/icon/icon-user-blue.png');
  }

  .block-doc:hover #icon-login-doc {
    background-image: url('./../../assets/images/icon/icon-doc-blue.png');
  }

  .block-out:hover #icon-login-out {
    background-image: url('./../../assets/images/icon/icon-out-blue.png');
  }

  .block-user:hover,
  .block-doc:hover,
  .block-out:hover {
    color: #003168;
  }

  .active-lang {
    color: #003168;
    font-weight: 600;
  }
</style>